import maplibregl from 'maplibre-gl';
import { Protocol, PMTiles } from 'pmtiles';

/**
 * pmtiles protocol registrar (Phase 5.3 R-33 step 6、v1 main.tsx 踏襲)。
 *
 * maplibre-gl の addProtocol で `pmtiles://` URL を解決する Protocol を global に登録。
 * blob URL や remote URL を `pmtiles://<url>` に prefix した form で MapLibre source.url に指定すると、
 * このプロトコルが tile fetch を担当する。
 *
 * `registerPmtilesProtocol()` は idempotent (重複登録しない)。App 初期化 1 回呼出が前提。
 * `addPmtilesSource(url)` で remote / blob URL に対応する PMTiles オブジェクトを Protocol に追加。
 */

let registered = false;
let globalProtocol: Protocol | null = null;

export function registerPmtilesProtocol(): Protocol {
  if (registered && globalProtocol) return globalProtocol;
  const protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);
  globalProtocol = protocol;
  registered = true;
  return protocol;
}

/**
 * MapLibre source 用の `pmtiles://...` URL を返し、同時に PMTiles instance を protocol に登録。
 * `addProtocol` 登録済の前提 (呼出側で `registerPmtilesProtocol()` を実行済)。
 *
 * @param resourceUrl Blob URL (例: `blob:http://localhost:5173/abc-123`) or remote URL
 * @returns MapLibre source.url に渡せる文字列 (例: `pmtiles://blob:http://localhost:5173/abc-123`)
 */
export function addPmtilesSource(resourceUrl: string): string {
  if (!globalProtocol) {
    throw new Error('PMTiles protocol not registered. Call registerPmtilesProtocol() first.');
  }
  const pmtilesUrl = `pmtiles://${resourceUrl}`;
  globalProtocol.add(new PMTiles(resourceUrl));
  return pmtilesUrl;
}

/**
 * 既に追加した PMTiles を URL で削除 (cache 切替時 / unmount 時に使用)。
 */
export function removePmtilesSource(resourceUrl: string): void {
  if (!globalProtocol) return;
  // pmtiles@3.x の Protocol は内部 Map に PMTiles を保持、明示 delete API なし。
  // 完全な解放は protocol.tiles.delete(url) の internal access が必要だが
  // public API として未提供。実害は blob URL 1 件分の memory hold のみ。
  // unmount 時には呼出側で URL.revokeObjectURL(blobUrl) を実施すること。
  void resourceUrl;
}
